import {
  RegFormData,
  RegFormErrors,
  RegTouchFields,
} from "../../Components/common/types";

export function handleRegBlur(
  name: keyof RegFormData,
  value: string,
  touched: RegTouchFields,
  setTouched: React.Dispatch<React.SetStateAction<RegTouchFields>>,
  regValidateFieldWrapper: (name: keyof RegFormData, value: string) => void
) {
  console.log("Touch state handleBlur", touched);
  setTouched({
    ...touched,
    [name]: true,
  });
  // console.log("handleBlur:", name, "value:", value);
  regValidateFieldWrapper(name, value);
}

//validate field on focus and then blur if left empty
export function regValidateField(
  name: keyof RegFormData,
  value: string,
  errors: RegFormErrors,
  setErrors: React.Dispatch<React.SetStateAction<RegFormErrors>>,
  regFormData: Partial<RegFormData>
) {
  // console.log('regValidateField - name:', name, 'value:', value);
  const newErrors = { ...errors }; //collect all errors and show them at ones

  switch (name) {
    case "name":
      if (!value) {
        newErrors.name = "Full name is required.";
      } else {
        const nameParts = value.trim().split(" ");
        if (nameParts.length < 2) {
          newErrors.name = "Please enter both first and last name.";
        } else {
          newErrors.name = ""; // Clear error if valid
        }
      }
      break;
    case "email":
      if (typeof value === "string") {
        if (!value) {
          newErrors.email = `Email is required`;
        } else if (!/\S+@\S+\.\S+/.test(value)) {
          newErrors.email = `${name} address is invalid`;
        } else {
          newErrors.email = "";
        }
      }
      break;
    case "password":
      if (!value) {
        newErrors.password = "Password is required.";
      } else if (
        !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d\W_]{8,}$/.test(value)
      ) {
        newErrors.password =
          "Password must be at least 8 characters long, include an uppercase letter, a lowercase letter, and a number.";
      } else {
        newErrors.password = ""; // Clear error if valid
      }
      // 🔹 Revalidate confirmPassword when newPassword changes
      if (
        regFormData.confirmPassword &&
        regFormData.confirmPassword !== value
      ) {
        newErrors.password = "Password does not match";
      } else {
        newErrors.confirmPassword = ""; // Clear error if they match
      }
      break;
    case "confirmPassword":
      if (!value) {
        newErrors.confirmPassword = "You need to confirm your password";
      } else if (regFormData.password !== value) {
        newErrors.confirmPassword = "Password does not match";
      } else {
        newErrors.confirmPassword = ""; // Clear error if valid
      }
      break;
      case "otp":
        if (!value) {
          newErrors.otp = "Enter the code sent to your email.";
        } else {
          const codeStr = String(value);
          if (!/^\d{6}$/.test(codeStr)) {
            newErrors.otp = "Only 6 digits required.";
          } else {
            newErrors.otp = ""; // Clear error if valid
          }
        }
        break
    default:
      break;
  }

  setErrors(newErrors);
  // console.log('regValidateField - errors:', newErrors);
}

//validate on empty field submission
export function regValidate(
  regFormData: RegFormData,
  errors: RegFormErrors,
  setErrors: React.Dispatch<React.SetStateAction<RegFormErrors>>,
  setTouched: React.Dispatch<React.SetStateAction<RegTouchFields>>
): boolean {
  // console.log('validate - regFormData:', regFormData);
  let formIsValid = true;

  (Object.keys(regFormData) as (keyof RegFormData)[]).forEach((key) => {
    const value = regFormData[key];
    //check if value exists and validate it
    if (value !== undefined) {
      regValidateField(key, value, errors, setErrors, regFormData);
    }

    // Check if the field is submitted empty or undefined
    if (!value) {
      formIsValid = false;
      errors[key] = `${
        (key as string).charAt(0).toUpperCase() + (key as string).slice(1)
      } is required`; //a case of empty fields submitted
    }
  });

  setErrors(errors); //a case of empty fields submitted

  // Mark all fields as touched
  setTouched({
    name: true,
    email: true,
    password: true,
    confirmPassword: true,
    otp: true
  });

  return formIsValid;
}
